import { Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"
import { NavArrowRight } from "iconoir-react"
import { Link, useLocation } from "react-router-dom"

import { PropsWithClassName } from "@/lib/types"

import { buildTrail } from "./utils"

const Breadcrumbs = ({ className }: PropsWithClassName) => {
  const location = useLocation()
  const { pathname, state } = location

  const trail = buildTrail(pathname, state?.from)

  if (trail.length === 0) {
    return null
  }

  return (
    <div className={clsx("flex flex-wrap items-start gap-1", className)}>
      {trail.map((item, index) => {
        const isLast = index === trail.length - 1

        return (
          <div key={item.path} className="flex items-center gap-1">
            {!isLast ? (
              <>
                <Link to={item.path}>
                  <Typography
                    variant="smallBody"
                    className="text-onSurface-400 hover:underline"
                  >
                    {item.label}
                  </Typography>
                </Link>
                <Typography variant="smallBody" className="text-onSurface-400">
                  <NavArrowRight className="!size-2" strokeWidth={2} />
                </Typography>
              </>
            ) : (
              <Typography variant="smallBody">{item.label}</Typography>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Breadcrumbs
